// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ep-0";